import { saturate } from './Math';
export function inCubic(t) {
    return saturate(Math.pow(t, 3));
}
export function outCubic(t) {
    return saturate(1 - inCubic(1 - t));
}
export function inOutCubic(t) {
    if (t < 0.5)
        return saturate(inCubic(t * 2.0) / 2.0);
    else
        return saturate(1 - inCubic((1 - t) * 2.0) / 2.0);
}
export function jumpInOutCubic(t, jumpT) {
    if (t <= jumpT)
        return outCubic(t / jumpT);
    else
        return 1.0 - inOutCubic((t - jumpT) / (1.0 - jumpT));
}
export function jumpInOutCirc(t, jumpT) {
    if (t <= jumpT)
        return outCirc(t / jumpT);
    else
        return 1.0 - inOutCirc((t - jumpT) / (1.0 - jumpT));
}
export function inQuad(t) {
    return saturate(t * t);
}
export function outQuad(t) {
    return saturate(1 - inQuad(1 - t));
}
export function inCirc(t) {
    return saturate(-(Math.sqrt(1 - t * t) - 1));
}
export function outCirc(t) {
    return Math.sqrt(1 - Math.pow((t - 1), 2));
}
export function inOutCirc(t) {
    if (t < 0.5)
        return saturate(inCirc(t * 2.0) / 2.0);
    return saturate(1 - inCirc((1 - t) * 2.0) / 2.0);
}
export function outElastic(tIn) {
    const t = saturate(tIn);
    const p = 0.3;
    const s = (p / (2 * Math.PI)) * 1.5707963267948966;
    return Math.pow(2, (-10 * t)) * Math.sin(((t - s) * (2 * Math.PI)) / p) + 1.0;
}
